'use client';

import config from 'config-base';
import { useState } from 'react';
import { NewsletterSubscribeProps } from './types';
import EditButton from '@/components/Button/EditButton';
import Button from '@/components/Button/BaseButton';
import FormComponent from '@/components/Form';
import useExternalRedirect from '@/hooks/useExternalRedirect';
import clsx from 'clsx';
import styles from './NewsletterSubscribe.module.css';

const initialValues = {
  email: '',
};

export default function NewsletterSubscribe({ mailingList, className }: Readonly<NewsletterSubscribeProps>) {
  const { redirect } = useExternalRedirect();
  const [subscribeForm, setSubscribeForm] = useState<Record<string, string>>(initialValues);
  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    if (subscribeForm.email) {
      return redirect(encodeURI(`${config.subscribeNewsletterUrl}?subscribeMe=${subscribeForm.email}&subscribe=`));
    }
    redirect(encodeURI(config.subscribeNewsletterUrl));
  };

  const handleOnchange = (val: React.ChangeEvent<HTMLInputElement>) =>
    setSubscribeForm((prevState) => ({ ...prevState, email: val.target.value }));

  return (
    <section className={clsx(styles.subscribeWrapper, className)}>
      <div className={styles.container}>
        <FormComponent className={styles.subscribeForm} onSubmit={handleSubmit}>
          <div className={styles.subscribeTitleH1}>Want More?</div>
          <div className={styles.subscribeTitleH2}>Join Our Email List for News and Deals!</div>
          <div className={styles.fieldWrapper}>
            <input
              data-testid={'newsletter-subscribe-input'}
              value={subscribeForm.email}
              placeholder="Email*"
              type="text"
              name="email"
              onChange={handleOnchange}
              className={styles.subscribeField}
            />
            <Button type="submit" classes={styles.submitButton} ariaLabel={'Sign Up!'}>
              <span>Sign Up!</span>
            </Button>
          </div>
        </FormComponent>
        <EditButton
          id="edit-newsletter-subscribe"
          recordId="33"
          slug="promoAlertMessageEdit"
          className={styles.editIcon}
        />
        {mailingList && <div className={styles.mailingList} dangerouslySetInnerHTML={{ __html: mailingList }} />}
      </div>
    </section>
  );
}
